import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMingo } from '../context/MingoContext';
import { navigateBackToPrevious } from '../lib/goBack';

/**
 * Sticky page title with ← back (explicit return path from navigation state, else browser history, else home).
 * B 레이아웃: 뒤로가기 absolute left, 제목 absolute center, 우측 슬롯 absolute right.
 * @param {React.ReactNode} [props.rightSlot] — 우측 액션(들); flex row gap 8px
 */
function PageHeaderWithBack({ title, onBack, className = '', rightSlot = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useMingo();
  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    navigateBackToPrevious(navigate, location);
  };
  return (
    <header className={`mingo-page-header mingo-page-header--with-back mingo-page-header--layout-b${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        className="mingo-page-header__back"
        onClick={handleBack}
        aria-label={t('common.back')}
      >
        ←
      </button>
      <div className="mingo-page-header__title-wrap">
        <h1 className="mingo-page-header__title mingo-page-header__title--centered">{title}</h1>
      </div>
      <div className="mingo-page-header__right-slot">
        {rightSlot != null && rightSlot !== false ? rightSlot : null}
      </div>
    </header>
  );
}

export default PageHeaderWithBack;
